import { useState } from 'react'
import { supabase } from './supabaseClient'

export default function Auth({ theme }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isSignUp, setIsSignUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('success')

  const handleSubmit = async () => {
    setLoading(true)
    setMessage('')

    if (isSignUp) {
      const { error } = await supabase.auth.signUp({ email, password })
      if (error) {
        setMessage(error.message)
        setMessageType('error')
      } else {
        setMessage('Check your email to confirm your account.')
        setMessageType('success')
      }
    } else {
      const { error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) {
        setMessage(error.message)
        setMessageType('error')
      }
    }

    setLoading(false)
  }

  const inputStyle = {
    width: '100%',
    background: theme.surfaceAlt,
    border: `1px solid ${theme.border}`,
    color: theme.text,
    padding: '10px 12px',
    fontSize: 14,
    fontFamily: "'Nunito Sans', sans-serif",
    boxSizing: 'border-box',
    outline: 'none',
  }

  const labelStyle = {
    fontSize: 11,
    color: theme.textSecondary,
    marginBottom: 6,
    letterSpacing: '0.1em',
    fontFamily: "'Open Sans', sans-serif",
    textTransform: 'uppercase',
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: theme.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        width: 400,
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        padding: '48px 40px',
      }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img
            src="/images/logo-dark.png"
            alt="Ravenwood Writing Academy"
            style={{ height: 80, marginBottom: 16 }}
          />
          <div style={{
            fontSize: 22,
            color: theme.text,
            fontFamily: "'Cardo', serif",
            marginBottom: 4,
          }}>
            Writer OS
          </div>
          <div style={{
            fontSize: 11,
            color: theme.textSecondary,
            fontFamily: "'Open Sans', sans-serif",
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
          }}>
            {isSignUp ? 'Create your account' : 'Sign in to your account'}
          </div>
        </div>

        {/* Divider */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 28,
        }}>
          <div style={{ flex: 1, height: 1, background: theme.border }} />
          <div style={{ color: theme.accent, fontSize: 8 }}>◆</div>
          <div style={{ flex: 1, height: 1, background: theme.border }} />
        </div>

        {/* Email */}
        <div style={{ marginBottom: 16 }}>
          <div style={labelStyle}>Email</div>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={inputStyle}
          />
        </div>

        {/* Password */}
        <div style={{ marginBottom: isSignUp ? 16 : 24 }}>
          <div style={labelStyle}>Password</div>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={inputStyle}
          />
        </div>

        {/* Trial helper text — signup only */}
        {isSignUp && (
          <div style={{
            fontSize: 12, color: theme.textMuted, marginBottom: 20,
            fontFamily: "'Nunito Sans', sans-serif", lineHeight: 1.5,
          }}>
            Start with a free 30-day trial. No credit card required.
          </div>
        )}

        {/* Message */}
        {message && (
          <div style={{
            marginBottom: 16,
            padding: '10px 12px',
            background: messageType === 'error' ? '#fee2e233' : theme.statusGreenBg,
            border: `1px solid ${messageType === 'error' ? '#e05c5c55' : theme.statusGreenText + '33'}`,
            color: messageType === 'error' ? '#e05c5c' : theme.statusGreenText,
            fontSize: 13,
            fontFamily: "'Nunito Sans', sans-serif",
          }}>
            {message}
          </div>
        )}

        {/* Submit */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%',
            background: theme.accent,
            color: '#0a2342',
            border: 'none',
            padding: '13px',
            fontSize: 11,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 700,
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1,
            marginBottom: 12,
          }}
        >
          {loading ? 'Please wait...' : isSignUp ? 'Create Account & Start Free Trial' : 'Sign In'}
        </button>

        {/* Toggle */}
        <div
          onClick={() => {
            setIsSignUp(!isSignUp)
            setMessage('')
          }}
          style={{
            textAlign: 'center',
            fontSize: 12,
            color: theme.textSecondary,
            cursor: 'pointer',
            fontFamily: "'Nunito Sans', sans-serif",
          }}
        >
          {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
        </div>

      </div>
    </div>
  )
}
